/* ================================================
   VIBE.JS - Minimal Interactions
   ================================================ */

(function() {
  'use strict';

  // Respect prefers-reduced-motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Product Gallery Thumbnails
  function initProductGallery() {
    const galleries = document.querySelectorAll('[data-product-gallery]');
    
    galleries.forEach(gallery => {
      const mainImage = gallery.querySelector('[data-main-image]');
      const thumbnails = gallery.querySelectorAll('[data-thumbnail]');
      
      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', function() {
          const newSrc = this.dataset.image;
          const newSrcset = this.dataset.srcset || '';
          
          if (mainImage) {
            mainImage.src = newSrc;
            if (newSrcset) mainImage.srcset = newSrcset;
          }
          
          // Update active state
          thumbnails.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
        });

        // Keyboard support
        thumb.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
      });
    });
  }

  // Countdown Timer
  function initCountdown() {
    const countdowns = document.querySelectorAll('[data-countdown]');
    
    countdowns.forEach(countdown => {
      const targetDate = new Date(countdown.dataset.countdown).getTime();
      
      function updateCountdown() {
        const now = new Date().getTime();
        const distance = targetDate - now;
        
        if (distance < 0) {
          countdown.innerHTML = '<span class="countdown__expired">LIVE NOW</span>';
          return;
        }
        
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        countdown.innerHTML = `
          <span class="countdown__unit"><strong>${days}</strong>D</span>
          <span class="countdown__unit"><strong>${hours}</strong>H</span>
          <span class="countdown__unit"><strong>${minutes}</strong>M</span>
          <span class="countdown__unit"><strong>${seconds}</strong>S</span>
        `;
      }
      
      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  }

  // Accordion/Collapsible
  function initAccordion() {
    const accordions = document.querySelectorAll('[data-accordion-trigger]');
    
    accordions.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const targetId = this.dataset.accordionTrigger;
        const content = document.getElementById(targetId);
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        this.setAttribute('aria-expanded', !isExpanded);
        content.hidden = isExpanded;
        
        if (!prefersReducedMotion && !isExpanded) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  // Ticker Pause on Hover
  function initTicker() {
    const tickers = document.querySelectorAll('[data-ticker-pause]');
    
    tickers.forEach(ticker => {
      ticker.addEventListener('mouseenter', function() {
        this.style.animationPlayState = 'paused';
      });
      
      ticker.addEventListener('mouseleave', function() {
        this.style.animationPlayState = 'running';
      });
    });
  }

  // Variant Selection Sync
  function initVariantSelector() {
    const forms = document.querySelectorAll('[data-product-form]');
    
    forms.forEach(form => {
      const variantSelect = form.querySelector('select[name="id"]');
      const optionButtons = form.querySelectorAll('[data-variant-option]');
      
      if (!variantSelect) return;
      
      optionButtons.forEach(button => {
        button.addEventListener('click', function() {
          const optionName = this.dataset.optionName;
          const optionValue = this.dataset.optionValue;
          
          // Update active state
          form.querySelectorAll(`[data-option-name="${optionName}"]`).forEach(btn => {
            btn.classList.remove('active');
          });
          this.classList.add('active');
          
          // Find matching variant
          const selectedOptions = {};
          form.querySelectorAll('[data-variant-option].active').forEach(btn => {
            selectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
          });
          
          // Update hidden select (simplified - assumes options match)
          const options = Array.from(variantSelect.options);
          const matchingOption = options.find(option => {
            const variantData = JSON.parse(option.dataset.variant || '{}');
            return Object.keys(selectedOptions).every(key => 
              variantData[key] === selectedOptions[key]
            );
          });
          
          if (matchingOption) {
            variantSelect.value = matchingOption.value;
            variantSelect.dispatchEvent(new Event('change'));
          }
        });
      });
    });
  }

  // Initialize all
  document.addEventListener('DOMContentLoaded', function() {
    initProductGallery();
    initCountdown();
    initAccordion();
    initTicker();
    initVariantSelector();
  });

})();
